import { PROMO_ID } from 'reactApp/appHelpers/featuresHelpers/features/vigboPrintFakedoor';
import { renderFakedoorModal } from 'reactApp/ui/FakedoorModal/FakedoorModal';
import { createDwhTemplatedSender } from 'reactApp/utils/dwh';

const sendRadar = createDwhTemplatedSender({ eventCategory: 'vigbo_modal_confirm', replacementSymbol: '_' });

export const renderVigboPrintFakedoorModal = () => {
    const title = 'Функция пока в разработке';
    const text = 'Спасибо – теперь знаем, что вам интересно. Сообщим сразу, как появится эта функция';
    const primaryButtonText = 'Сообщите мне';
    const secondaryButtonText = 'Закрыть';

    const onClick = () => {
        sendRadar({
            action: 'fakedoor_click',
        });
    };

    const onClose = () => {
        sendRadar({
            action: 'fakedoor_close',
        });
    };

    sendRadar({
        action: 'fakedoor_show',
    });

    renderFakedoorModal({
        qaId: PROMO_ID,
        title,
        text,
        primaryButtonText,
        secondaryButtonText,
        onClick,
        onClose,
    });
};
